import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import styled from "styled-components";
import { PlateElement, type PlateElementProps } from "@platejs/core/react";
interface ListElementProps extends PlateElementProps {
  variant?: "ol" | "ul";
}
export const ListElement: FC<ListElementProps> = t0 => {
  const $ = _c(10);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "ul" : t1;
  let t2;
  if ($[4] !== children || $[5] !== variant) {
    t2 = <List as={variant}>{children}</List>;
    $[4] = children;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <PlateElement {...props}>{t2}</PlateElement>;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
const List = styled.ul`
	&& {
		list-style: ${props => props.as === "ol" ? "decimal" : "disc"};
		padding-inline-start: 1.5rem;
	}
`;